
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import Message from '@/components/message.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		logisticsTplList,
		doLogisticsTpl
	} from '@/api/logistics';
	import PageFooter from '@/components/page-footer.vue';
	
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"
	@Component({
		name: 'desc-list',
		components: {
			'slz-message': Message,
			PageFooter,
			PickerDate
		},
		filters: {
			analysisArea(val: any) {
				const list: any = []
				val.map((res: any) => {
					const arr: any = []
					arr[0] = res.province
					if (res.city) arr[1] = res.city
					if (res.county) arr[2] = res.county
					list.push(arr.toString())
				})
				return list.join(';')
			}
		}
	})
	export default class DescList extends Vue {
		private providerId = +this.$route.query.id || 0;
		private templateKey = '';
		private filterTime = ''
		private list: any = [];
		private showMessage = false;
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private currentId = 0;

		private mounted() {
			this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
			this.getList();
		}

		private handleClickRow(row: any, column: any) {
			if (column.label === '操作') return;
			const $table: any = this.$refs.multipleTable
			$table.toggleRowExpansion(row)
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.pageNo = 1;
			this.templateKey = '';
			this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
			this.getList();
		}

		/**
		 * 删除操作
		 */
		private handleDel(id: number) {
			this.currentId = id;
			this.showMessage = true
		}

		/**
		 * 跳转到创建页面
		 */
		private toCreate() {
			this.$router.push({
				name: 'Template_Detail'
			})
		}

		/**
		 * 跳转到详情
		 */
		private toDetail(id: string) {
			this.$router.push({
				name: 'Template_Detail',
				query: {
					id: id,
					providerId: this.providerId+'',
				}
			})
		}

		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}

		/**
		 * 跳转到供应商模版列表
		 */
		private async getList() {
			let params: any = {
				ProviderId: this.providerId,
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				Keywords: this.templateKey
			}
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				params.EndTime = nextDay(dt[1],1)
			}
			
			try {
				const res: any = await logisticsTplList(params)
				this.list = res.Result;
				// this.pageNo === 1 && this.list.unshift({
				// 	Id: 0,
				// 	AreaIds:[],
				// 	AreaNames: ['全国包邮'], // 配送地区名,
				// 	FirstCountToNumber: 0, // 首件(个),
				// 	FirstMoneyToNumber: 0,// 首件运费（元）,
				// 	ContinueCountToNumber: 0,// 续件(个),
				// 	ContinueMoneyToNumber: 0,// 续件续费（元）
				// })
				this.total = res.Result.Total;
			} catch (err) {
				console.log(err);
			}
		}

		/**
		 * 确认删除
		 */
		private async confirmDel() {
			try {
				await doLogisticsTpl({
					Id: this.currentId,
				})
				this.getList()
			} catch (err) {
				console.log(err)
			}
		}
	}
